// Exported from EmitterTool
export default {
  "name": "Bouncing Ball",
  "effectKey": "basic",
  "showGrid": true,
  "EmitterPanel": {
    "shape": "dot",
    "showShape": true,
    "settings": {
      "radius": 1,
      "width": 2,
      "height": 2,
      "rotationDeg": 0,
      "angleDeg": 0,
      "spreadDeg": 30,
      "minDist": 0,
      "maxDist": 3,
      "pulseEnabled": false,
      "spawnFromOrigin": false,
      "spawnMode": "shape",
      "feederCount": 3,
      "feederRadiusM": 0.3,
      "feederJitterPct": 25,
      "beamEnabled": true,
      "beamBaseWidthPx": 24,
      "beamMaxLengthPx": 600,
      "beamCoreColor": "#ffffff",
      "beamGlowColor": "#66ccff",
      "beamCoreAlpha": 1,
      "beamGlowAlpha": 0.5,
      "beamHardCap": false,
      "beamCollideWithWalls": true,
      "beamPulseSpeed": 0.8,
      "beamNoise": 0.2,
      "beamNoiseSpeed": 1,
      "beamTileW": 128,
      "beamAngleDeg": 0,
      "startDeg": 0,
      "endDeg": 90,
      "arcSweepDeg": 90,
      "arcRotationDeg": 0,
      "rotationAnimEnabled": false,
      "rotationAnimDir": "ccw",
      "rotationAnimSpeedDegS": 45,
      "rotationAffectsParticles": true,
      "overlayCling": false
    },
    "rule": {
      "fireMode": "rule",
      "ruleStyle": "timed",
      "ruleDurationS": 0.5
    }
  },
  "TargetingPanel": {
    "presetId": "point",
    "rangeM": 51.5,
    "headSpeedMps": 40
  },
  "SpritePanel": {
    "mode": "single",
    "selectedSprite": "mc_fx-impact_02",
    "selectedSprites": [
      "mc_fx-impact_02"
    ],
    "selectedAnimFrames": [],
    "animFps": 12
  },
  "ParticlesPanel": {
    "pps": 100,
    "maxAlive": 1,
    "speedMin": 20,
    "speedMax": 20,
    "lifespanMode": "time",
    "lifeMinS": 2.5,
    "lifeMaxS": 4,
    "rangeMeters": 10,
    "targetKillDistMeters": 0.25,
    "alphaStart": 1,
    "alphaEnd": 1,
    "scaleStart": 0.3,
    "scaleEnd": 0.3,
    "blendMode": "ADD",
    "tintEnabled": false,
    "tintStart": "#ffffff",
    "tintEnd": "#ffffff",
    "tintEase": "linear",
    "facingMode": "deg_from_origin",
    "facingDegFromOrigin": 0
  },
  "OrbitPanel": {
    "orbitEnabled": false,
    "orbitDirection": "ccw",
    "orbitSpeedAbsDps": 90,
    "orbitSpeedDegPerS": 90,
    "orbitLockRadii": true,
    "orbitRadiusMinM": 1,
    "orbitRadiusMaxM": 1,
    "orbitShape": "circle",
    "orbitEllipseRxM": 1,
    "orbitEllipseRyM": 1,
    "orbitEllipseTiltDeg": 0,
    "orbitStartPhaseMode": "random",
    "orbitStartPhaseJitterDeg": 30,
    "orbitApplyMode": "all",
    "orbitApplyPercent": 100
  },
  "RotationPanel": {
    "rotateEnabled": true,
    "rotateDirection": "ccw",
    "rotateSpeedAbsDps": 90,
    "rotateSpeedDegPerS": 90
  },
  "GravityPanel": {
    "gravityEnabled": false,
    "gravitySpeed": 0,
    "gravityLingerS": 0
  },
  "CollisionPanel": {
    "useWalls": true,
    "wallResponse": "bounce",
    "useTokenCollision": false,
    "tokenResponse": "none",
    "collisionEffectEnabled": false,
    "collisionSprite": "",
    "collisionScale": 1,
    "collisionAlpha": 1,
    "collisionLifespanMs": 400,
    "collisionFxRotationMode": "none"
  },
  "GlowPanel": {
    "glowEnabled": true,
    "glowPercent": 100,
    "glowIntensity": 1,
    "glowReachM": 8,
    "glowDurationS": 0.5,
    "tintEnabled": false,
    "tintStart": "#ffffff",
    "tintEnd": "#ffffff"
  },
  "parent": {
    "emitterShape": "dot",
    "shapeSettings": {
      "radius": 1,
      "width": 2,
      "height": 2,
      "rotationDeg": 0,
      "angleDeg": 0,
      "spreadDeg": 30,
      "minDist": 0,
      "maxDist": 3,
      "pulseEnabled": false,
      "spawnFromOrigin": false,
      "spawnMode": "shape",
      "feederCount": 3,
      "feederRadiusM": 0.3,
      "feederJitterPct": 25,
      "beamEnabled": true,
      "beamBaseWidthPx": 24,
      "beamMaxLengthPx": 600,
      "beamCoreColor": "#ffffff",
      "beamGlowColor": "#66ccff",
      "beamCoreAlpha": 1,
      "beamGlowAlpha": 0.5,
      "beamHardCap": false,
      "beamCollideWithWalls": true,
      "beamPulseSpeed": 0.8,
      "beamNoise": 0.2,
      "beamNoiseSpeed": 1,
      "beamTileW": 128,
      "beamAngleDeg": 0,
      "startDeg": 0,
      "endDeg": 90,
      "arcSweepDeg": 90,
      "arcRotationDeg": 0,
      "rotationAnimEnabled": false,
      "rotationAnimDir": "ccw",
      "rotationAnimSpeedDegS": 45,
      "rotationAffectsParticles": true,
      "overlayCling": false
    },
    "effectSettings": {
      "fogHidden": false,
      "fogAlpha": 1,
      "orbitMode": "aroundOrigin",
      "rotateEnabled": false,
      "rotateDirection": "ccw",
      "rotateSpeedAbsDps": 90,
      "rotateSpeedDegPerS": 90,
      "spriteMode": "single",
      "selectedSprite": "mc_fx-impact_02",
      "selectedSprites": [
        "mc_fx-impact_02"
      ],
      "selectedAnimFrames": [],
      "spriteAnimatedEnabled": false,
      "pps": 100,
      "maxAlive": 1,
      "speedMin": 20,
      "speedMax": 20,
      "lifespanMode": "time",
      "lifeMinS": 2.5,
      "lifeMaxS": 4,
      "rangeMeters": 10,
      "targetKillDistMeters": 0.25,
      "alphaStart": 1,
      "alphaEnd": 1,
      "scaleStart": 0.3,
      "scaleEnd": 0.3,
      "blendMode": "ADD",
      "tintEnabled": false,
      "tintStart": "#ffffff",
      "tintEnd": "#ffffff",
      "tintEase": "linear",
      "facingMode": "deg_from_origin",
      "facingDegFromOrigin": 0,
      "orbitEnabled": false,
      "orbitDirection": "ccw",
      "orbitSpeedAbsDps": 90,
      "orbitSpeedDegPerS": 90,
      "orbitLockRadii": true,
      "orbitRadiusMinM": 1,
      "orbitRadiusMaxM": 1,
      "orbitShape": "circle",
      "orbitEllipseRxM": 1,
      "orbitEllipseRyM": 1,
      "orbitEllipseTiltDeg": 0,
      "orbitStartPhaseMode": "random",
      "orbitStartPhaseJitterDeg": 30,
      "orbitApplyMode": "all",
      "orbitApplyPercent": 100,
      "orbitGroupTransform": false,
      "gravityEnabled": false,
      "gravitySpeed": 0,
      "gravityLingerS": 0,
      "glowEnabled": true,
      "glowPercent": 70,
      "glowIntensity": 0.95,
      "glowReachM": 4,
      "glowReachPx": 0,
      "glowDurationS": 3.05,
      "useWalls": true,
      "wallResponse": "bounce",
      "useTokenCollision": false,
      "tokenResponse": "none",
      "collisionEffectEnabled": false,
      "collisionScale": 1,
      "collisionAlpha": 1,
      "collisionLifespanMs": 400,
      "collisionFxRotationMode": "none"
    },
    "selectedSprite": "mc_fx-impact_02",
    "showShape": true
  },
  "layers": []
};
